import Sentence from './sentence';
import { SectionProps } from '../props';

/** A react component corresponding to a concrete section */
function Section(props: SectionProps) {
    if (props.annotationScheme.unit === "token") {
        const annotationScheme = props.annotationScheme;

        if (props.sentenceList) {
            const sentences = props.sentenceList.map(
                ps => <Sentence 
                       key={ 'sentence-' + ps.uuid.uuidString } 
                       annotationScheme={ annotationScheme }
                       activeStructureIds={ props.activeStructureIds }
                       situationMentionSetList={ props.situationMentionSetList }
                       situationSetList={ props.situationSetList }
                       {...ps} 
                      />
            );
            // return <>{sentences}</>;
            return <span className="section">{sentences}</span>;
        } else {
            alert("No sentenceList found for " + props.uuid.uuidString);
            return null;
        }
    } else {
        alert("Annotations for units larger than token spans is not supported");
        return null;
    }

}

export default Section;